import { cn } from '../../lib/utils'

export function Toggle({ checked, onChange, label, description }) {
  return (
    <label className="flex items-start gap-3 cursor-pointer select-none">
      <div className="relative mt-0.5 flex-shrink-0">
        <input type="checkbox" className="sr-only" checked={checked} onChange={e => onChange(e.target.checked)} />
        <div className={cn(
          'w-10 h-6 rounded-full transition-colors duration-200',
          checked ? 'bg-indigo-600' : 'bg-gray-200'
        )} />
        <div className={cn(
          'absolute top-1 left-1 w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-200',
          checked && 'translate-x-4'
        )} />
      </div>
      {(label || description) && (
        <div>
          {label && <p className="text-sm font-medium text-gray-700 leading-none">{label}</p>}
          {description && <p className="text-xs text-gray-400 mt-0.5">{description}</p>}
        </div>
      )}
    </label>
  )
}
